/* eslint-disable */
var $ = window.jQuery = require('jquery');
import draggable from 'vuedraggable'
import Vue from 'vue'
import VueHighlightJS from 'vue-highlightjs'
import {
  bus
} from '../../main';
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
import SectionFile from '../section-file-create/index';
import AddAssignment from '../add-assignment/index';
import SectionFileEdit from '../section-file-edit/index';
import CourseSectionEdit from '../course-section-edit/index';
import AssignmentList from '../assignmentList/index';
import AssignmentFile from '../assignment-file/index';
import UpdateAssignment from '../edit-assignment/index';
import UpdateAssignmentFile from '../edit-assignment-files/index';
import AddTopic from '../add-topic/index';
import EditTopic from '../edit-topic/index';
import AddCode from '../section-code-create/index';
import EditCode from '../section-code-edit/index';
import { VueEditor } from "vue2-editor";

Vue.use(VueHighlightJS)

export default {
  name: 'course-files',
  components: {
    'section-file': SectionFile,
    'section-file-edit': SectionFileEdit,
    'course-section-edit': CourseSectionEdit,
    'add-assignment': AddAssignment,
    'assignment-list': AssignmentList,
    'assignment-file': AssignmentFile,
    'edit-assignment': UpdateAssignment,
    'edit-assignment-file': UpdateAssignmentFile,
    'add-topic': AddTopic,
    'edit-topic': EditTopic,
    'section-code-create': AddCode,
    'section-code-edit': EditCode,
    draggable,
    VueEditor
  },
  props: [],
  data() {
    return {
      name: '',
      description: '',
      course: '',
      courseDetais: {},
      showTab: '',
      submitted: false,
      accordionVal: 0,
      sectionId: '',
      topicid: '',
      sectionfileIndex: '',
      sectionfileId: '',
      sectionIndex: '',
      editSectionFile: false,
      editSectionCode: false,
      editcourseSection: false,
      courseSectionId: '',
      removesectionId: '',
      activeStatusSectionId: '',
      activeStatusSection: Boolean,
      activeStatusSectionFileId: '',
      activeStatusSectionFile: Boolean,
      is_active: Boolean,
      index: '',
      addNewFilePopup: false,
      addNewCodePopup: false,
      addAssignmentPopup: false,
      assignmentId: '',
      activeStatusAssignmentID: '',
      activeStatusAssignment: Boolean,
      addAssignmentFilePopup: false,
      assignmentfileId: '',
      removeAssignmentId: '',
      updateAssignmentById: '',
      updateAssignmentPopup: false,
      removeAssignmentFileId: '',
      activeStatusAssignmentFileId: '',
      activeStatusAssignmentFile: Boolean,
      updateAssignmentFilesPopup: false,
      updateAssignmentFilesId: '',
      moveSectionIndex: '',
      moveSectionId: '',
      addTopicPopup: false,
      sectionIdForTopicid: '',
      activeStatusTopicId: '',
      activeStatusTopic: Boolean,
      removeTopicById: '',
      updateTopicid: '',
      editcourseTopic: false,
      moveTopicIndex: '',
      moveTopicId: '',
      toggleText: 'Expand All',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData:'',
      movedTopicIndex:'',
      movedTopicId:'',
      movedTopicFileIndex:'',
      movedTopicFileId:'',
      movedAssignmentId:'',
      movedAssignmentIndex:'',
      movedAssignmentFileId:'',
      movedAssignmentFileIndex:''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'getcourseSectionByIDDataState',
      'getsectionFilesState',
      'updateAssignmentDetailsDataState',
      'singleAssignmentState',
      'getAssignmentFilesDetailsState',
      'gettopicsdataState'
    ]),
    getCourseDetails() {
      this.courseDetais = this.$store.getters.getsectionbycourseIDState.data
      return this.courseDetais
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    }
  },
  mounted() {
    $('.popup_close').click(function() {
      $('.add_section_popup').removeClass('show');
    });
    bus.$on('hideEditSectionFilePopup', (data) => {
      this.editSectionFile = data;
    });
    bus.$on('hideEditSectionCodePopup', (data) => {
      this.editSectionCode = data;
    });
    bus.$on('hideEditSectionPopup', (data) => {
      this.editcourseSection = data;
    });
    bus.$on('HideAddNewFilePopup', (data) => {
      this.addNewFilePopup = data;
    });
    bus.$on('HideAddNewCodePopup', (data) => {
      this.addNewCodePopup = data;
    })
    bus.$on('HideAddAssignmentPopup', (data) => {
      this.addAssignmentPopup = data
    });
    bus.$on('HideAddNewAssignmentPopup', (data) => {
      this.addAssignmentFilePopup = data
    });
    bus.$on('HideUpdateAssignmentPopup', (data) => {
      this.updateAssignmentPopup = data
    });
    bus.$on('HideUpdateAssignmentFilePopup', (data) => {
      this.updateAssignmentFilesPopup = data
    });
    bus.$on('HideAddNewTopicPopup', (data) => {
      this.addTopicPopup = data
    });
    bus.$on('HideEditTopicPopup', (data) => {
      this.editcourseTopic = data
    });
    this.createEditor()
    this.renderMathJax()
  },
  methods: {
    renderMathJax(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub,this.$refs.mathJaxEl]);
        }
      },500)
    },
    createEditor() {
      CKEDITOR.replace('section_description',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['section_description'].on('change', () => {
        var content1Length = CKEDITOR.instances['section_description'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #section_description').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #section_description').removeClass('is-invalid')
          this.description = CKEDITOR.instances['section_description'].getData()
        }else{
          $('.custom_editor_for_option #section_description').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #section_description').addClass('is-invalid')
          this.description = ''
        }
      })
    },
    toggleAccordion(id) {
      this.renderMathJax()
      let accordionContent = '#assignmentSolution' + id;
      let accordiontitle = '#assignmentSolutionTitle' + id;
      $(accordionContent).toggleClass('show');
      $(accordiontitle).toggleClass('active');
      event.preventDefault();
      let totalSection = $('.course_part_list').length;
      let totalExpandLength = $('.course_part_list.show').length;
      if (totalExpandLength > 0) {
        this.toggleText = 'Collapse All';
      } else {
        this.toggleText = 'Expand All';
      }
    },
    toggleUploadAssignment(id) {
      let accordionContent = '#uploadassignmentContent' + id;
      let accordiontitle = '#uploadassignmentTitle' + id;
      $(accordionContent).toggleClass('show');
      $(accordiontitle).toggleClass('active');
      event.preventDefault()
      console.log(id)
    },
    getFileExtension(ext) {
      let newExt = '.' + ext;
      return this.checkFileExtension(newExt);
    },
    checkFileExtension(file) {
      let extension = file.substr((file.lastIndexOf('.') + 1));
      let extensionSplit = extension.split("?")[0]
      switch (extensionSplit) {
        case 'jpg':
          return require('./../../assets/images/filetype/jpg.png')
          break;
        case 'jpeg':
          return require('./../../assets/images/filetype/jpg.png')
          break;
        case 'png':
          return require('./../../assets/images/filetype/png.png')
          break;
        case 'gif':
          return require('./../../assets/images/filetype/jpg.png')
          break;
        case 'zip':
          return require('./../../assets/images/filetype/zip.png')
          break;
        case 'rar':
          return require('./../../assets/images/filetype/zip-1.png');
          break;
          break;
        case 'eps':
          return require('./../../assets/images/filetype/ai.png')
          break;
        case 'pdf':
          return require('./../../assets/images/filetype/pdf.png')
          break;
        case 'css':
          return require('./../../assets/images/filetype/css.png')
          break;
        case 'csv':
          return require('./../../assets/images/filetype/csv.png')
          break;
        case 'doc':
          return require('./../../assets/images/filetype/doc.png')
          break;
        case 'docx':
          return require('./../../assets/images/filetype/doc.png')
          break;
        case 'json':
          return require('./../../assets/images/filetype/json-file.png')
          break;
        case 'ppt':
          return require('./../../assets/images/filetype/ppt.png')
          break;
        case 'pptx':
          return require('./../../assets/images/filetype/ppt.png')
          break;
        case 'txt':
          return require('./../../assets/images/filetype/txt.png')
          break;
        case 'xls':
          return require('./../../assets/images/filetype/xls.png')
          break;
        case 'xlsx':
          return require('./../../assets/images/filetype/xls.png')
          break;
        case 'xml':
          return require('./../../assets/images/filetype/xml.png')
          break;
        case 'xlsm':
          return require('./../../assets/images/filetype/xls.png')
          break;
        case 'py':
          return require('./../../assets/images/filetype/python.png')
        case 'cpp':
          return require('./../../assets/images/filetype/cpp.png')
          break;
        case 'vbb':
          return require('./../../assets/images/filetype/coding.png')
          break;
        case 'vba':
          return require('./../../assets/images/filetype/coding.png')
          break;
        case 'java':
          return require('./../../assets/images/filetype/java.png')
          break;
        default:
          return require('./../../assets/images/filetype/d_file.png')
      }
    },
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id,
        tab_name:'material'
      }).then((res) => {
      }).catch((err) => {
        console.log(err, "getCourseDetailsAgain")
      })
    },
    validateSectionBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            description: this.description,
            course: this.courseDetais.id
          }
          this.$store.dispatch('course_section_create', data)
            .then((res) => {
              $('.add_section_popup').removeClass('show');
              this.getCourseDetailsAgain();
              this.name = '';
              toast.success(res.data.msg);
              this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
    getSectionId(id) {
      this.topicid = id;
      this.addNewFilePopup = true
    },
    showAddCodePopup(id) {
      this.topicid = id;
      this.addNewCodePopup = true;
    },
    getAssignment(id) {
      this.addAssignmentPopup = true
      this.assignmentId = id
    },
    getCourseSectionId(id) {
      this.courseSectionId = id;
      this.editcourseSection = true;
    },
    getSectionFileId(id) {
      this.sectionfileId = id;
      this.editSectionFile = true;
    },
    getSectionCodeId(id) {
      this.sectionfileId = id;
      this.editSectionCode = true;
    },
    PopupClose() {
      this.renderMathJax()
      this.editSectionFile = false;
      this.editcourseSection = false;
      this.editSectionCode = false;
    },
    removeItem(id, index, section_index) {
      $('#removeModal').modal()
      this.sectionfileId = id;
      this.sectionfileIndex = index;
      this.sectionIndex = section_index;
    },
    removeConfirmation(index) {
      let data = {
        id: this.sectionfileId
      }
      this.$store.dispatch('RemoveSectionByCourseFun', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg || 'File Removed Successfully');
            this.getCourseDetailsAgain();
            this.$delete(this.courseDetais.sections[this.sectionfileIndex].files, this.sectionfileIndex);

          }
        })
        .catch((err) => {})
    },
    removeSectionItem(id) {
      $('#removeSectionModal').modal()
      this.removesectionId = id;
    },
    removeSectionConfirmation() {
      let data = {
        id: this.removesectionId
      }
      this.$store.dispatch('remove_course_section_fun', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg || 'Section Removed Successfully');
            this.getCourseDetailsAgain();

          }
        })
        .catch((err) => {})
    },
    sectionActStatusFun(id) {
      this.activeStatusSectionId = id;
      let data = {
        id: this.activeStatusSectionId
      }
      this.$store.dispatch('get_course_section_fun', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            this.activeStatusSection = this.$store.getters.getcourseSectionByIDDataState.data.is_active
            this.submitted = true;
            if (this.activeStatusSection === true) {
              this.is_active = false
            }
            if (this.activeStatusSection === false) {
              this.is_active = true
            }
            let data = {
              is_active: this.is_active
            }
            this.$store.dispatch('edit_course_section_fun', {
              data: {
                data: data,
                id: this.activeStatusSectionId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success("Course Section Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        })
        .catch((err) => {})
    },
    sectionFileActStatusFun(id) {
      this.activeStatusSectionFileId = id;
      let data = {
        id: this.activeStatusSectionFileId
      }
      this.$store.dispatch('get_course_section_files_id', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            this.activeStatusSectionFile = this.$store.getters.getsectionFilesState.data.is_active
            this.submitted = true;
            if (this.activeStatusSectionFile === true) {
              this.is_active = false
            }
            if (this.activeStatusSectionFile === false) {
              this.is_active = true
            }
            let formData = new FormData();
            formData.append('is_active', this.is_active);
            this.$store.dispatch('UpdateStsOfSectionFileById', {
              data: {
                formdata: formData,
                id: this.activeStatusSectionFileId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success("Course File Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        })
        .catch((err) => {})
    },
    assignmentActStatusFun(id) {
      this.activeStatusAssignmentID = id;
      let data = {
        id: this.activeStatusAssignmentID
      }
      this.$store.dispatch('getSignleAssignmentActn', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.activeStatusAssignment = this.$store.getters.singleAssignmentState.is_active
            if (this.activeStatusAssignment === true) {
              this.is_active = false
            }
            if (this.activeStatusAssignment === false) {
              this.is_active = true
            }
            let data = {
              is_active: this.is_active,
            }
            this.$store.dispatch('updateAssignmentDetailsByID', {
              data: {
                data: data,
                id: this.activeStatusAssignmentID
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success("Assignment Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    addAssignmentFileFun(id) {
      this.addAssignmentFilePopup = true,
        this.assignmentfileId = id
    },
    // Remove Assignment Fun
    removeAssignmentItem(id) {
      $('#removeassignmentModal').modal()
      this.removeAssignmentId = id;
    },
    removeassignmentModalConfirmation() {
      let data = {
        id: this.removeAssignmentId
      }
      this.$store.dispatch('removeAssignmentById', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg || 'Assignment Removed Successfully');
            this.getCourseDetailsAgain();

          }
        })
        .catch((err) => {})
    },
    // Update Assignment
    editAssignmentByID(id) {
      this.updateAssignmentById = id,
        this.updateAssignmentPopup = true
    },
    // Remove Assignment File
    removeAssignmentFileById(id) {
      $('#removeassignmentFileModal').modal()
      this.removeAssignmentFileId = id;
    },
    removeassignmentFileModalConfirmation() {
      let data = {
        id: this.removeAssignmentFileId
      }
      this.$store.dispatch('removeAssignmentFileById', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg || 'Assignment File Removed Successfully');
            this.getCourseDetailsAgain();
          }
        })
        .catch((err) => {})
    },
    // Status Update Of Assignment Files
    statusUpdateAssignmentFileFun(id) {
      this.activeStatusAssignmentFileId = id;
      let data = {
        id: this.activeStatusAssignmentFileId
      }
      this.$store.dispatch('getAssignmentFileByIdFun', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            console.log(this.$store.getters.getAssignmentFilesDetailsState, 'active status')
            this.activeStatusAssignmentFile = this.$store.getters.getAssignmentFilesDetailsState.is_active
            this.submitted = true;
            if (this.activeStatusAssignmentFile === true) {
              this.is_active = false
              console.log(this.is_active)
            }
            if (this.activeStatusAssignmentFile === false) {
              this.is_active = true
              console.log(this.is_active)
            }
            let formData = new FormData();
            formData.append('is_active', this.is_active);
            this.$store.dispatch('updateAssignmentFileByID', {
              data: {
                formdata: formData,
                id: this.activeStatusAssignmentFileId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success("Assignment File Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        })
        .catch((err) => {})
    },
    // Update Assignment Files
    updateAssignmentFilesById(id) {
      this.updateAssignmentFilesId = id,
        this.updateAssignmentFilesPopup = true
    },
    SectionMovedFun: function({ relatedContext, draggedContext }) {
      this.movedSectionIndex = relatedContext.element.index
      this.movedSectionId = draggedContext.element.id
    },
    SectionMoveDragFun: function() {
      let data = {
        index: this.movedSectionIndex
      }
      this.$store.dispatch('updateIndexDragSection', {
        data: {
          data: data,
          id: this.movedSectionId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Section Index Updated Successfully");
        }
      }).catch((err) => {})
    },
    TopicFileMoveFun: function({ relatedContext, draggedContext }) {
      this.movedTopicFileIndex = relatedContext.element.index
      this.movedTopicFileId = draggedContext.element.id
    },
    TopicFileDragFun: function() {
      let data = {
        index: this.movedTopicFileIndex
      }
      this.$store.dispatch('updateIndexDragSectionFile', {
        data: {
          data: data,
          id: this.movedTopicFileId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Section File Index Updated Successfully");
        }
      }).catch((err) => {})
    },
    AssignmentsMoveFun: function({ relatedContext, draggedContext }) {
      this.movedAssignmentIndex = relatedContext.element.index
      this.movedAssignmentId = draggedContext.element.id
    },
    AssignmentsDragFun: function() {
      let data = {
        index: this.movedAssignmentIndex
      }
      this.$store.dispatch('updateIndexDragAssignment', {
        data: {
          data: data,
          id: this.movedAssignmentId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Assignment Index Updated Successfully");
        }
      }).catch((err) => {})
    },
    AssignmentsFilesMoveFun: function({ relatedContext, draggedContext }) {
      this.movedAssignmentFileIndex = relatedContext.element.index
      this.movedAssignmentFileId = draggedContext.element.id
    },
    AssignmentsFilesDragFun: function() {
      let data = {
        index: this.movedAssignmentFileIndex
      }
      this.$store.dispatch('updateIndexDragAssignmentFile', {
        data: {
          data: data,
          id: this.movedAssignmentFileId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Assignment File Index Updated Successfully");
        }
      }).catch((err) => {})
    },
    getSectionTopicId(id) {
      this.sectionIdForTopicid = id
      this.addTopicPopup = true
    },
    topicActStatusFun(id) {
      this.activeStatusTopicId = id;
      let data = {
        id: this.activeStatusTopicId
      }
      this.$store.dispatch('get_topics', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            this.activeStatusTopic = this.$store.getters.gettopicsdataState.data.is_active
            this.submitted = true;
            if (this.activeStatusTopic === true) {
              this.is_active = false
            }
            if (this.activeStatusTopic === false) {
              this.is_active = true
            }
            let formData = new FormData();
            formData.append('is_active', this.is_active);
            this.$store.dispatch('update_topic', {
              data: {
                formdata: formData,
                id: this.activeStatusTopicId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success("Topic Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        })
        .catch((err) => {})

    },
    updateTopicFun(id) {
      this.updateTopicid = id
      this.editcourseTopic = true
    },
    deleteTopicFun(id) {
      $('#removeTopicModal').modal()
      this.removeTopicById = id;
    },
    removeTopicModalConfirmation() {
      let data = {
        id: this.removeTopicById
      }
      this.$store.dispatch('delete_topic', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg || 'Topic Removed Successfully');
            this.getCourseDetailsAgain();
          }
        })
        .catch((err) => {})
    },
    TopicsMoveFun: function({ relatedContext, draggedContext }) {
      this.moveTopicIndex = relatedContext.element.index
      this.moveTopicId = draggedContext.element.id
    },
    TopicsDragFun: function() {
      let data = {
        index: this.moveTopicIndex
      }
      this.$store.dispatch('UpdateTopicByIndex', {
        data: {
          data: data,
          id: this.moveTopicId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Topic Index Updated Successfully");
        }
      }).catch((err) => {})
    },
    showCodeSnippet(id) {
      let codeSnippetElement = '#code_snippet_' + id;
      $(codeSnippetElement).toggleClass('show');
      $(codeSnippetElement).toggleClass('active');
    },
    toggleAllBlock() {
      if (this.toggleText == 'Expand All') {
        $('.course_part_list').addClass('show');
        $('.course_part_list').addClass('active');
        this.toggleText = 'Collapse All';
      } else {
        $('.course_part_list').removeClass('show');
        $('.course_part_list').removeClass('active');
        this.toggleText = 'Expand All';
      }
    }
  },
  beforeMount() {
    this.getCourseDetails;
  },
  watch: {
    getCourseDetails() {
      this.renderMathJax()
      return this.$store.getters.getsectionbycourseIDState.data
    }
  }
}